import React from 'react';

import {
  BaseModalFooter,
  BaseModal,
  BaseModalProps,
} from 'components/wrappers/BaseModal';
import { FullBOUserResponseModel } from 'api/backofficeApiClient';
import {
  mapSelftEployedProfileToRequest,
  SelfEmployedProfileFormValues,
} from './SelfEmployedProfileForm/mapUtils';
import BaseAlert from 'components/wrappers/BaseAlert';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import SubmitButton from 'components/formik/SubmitButton';
import SelfEmployedProfileForm from './SelfEmployedProfileForm';
import { saveSelfEmployedGeneralInfo } from 'redux/reducers/accountSlice';
import { saveRecruiterSelfEmployedGeneralInfo } from 'redux/reducers/recruiterSlice';
import { useAppDispatch } from 'hooks/useAppDispatch';

type Props = {
  formRef: any;
  isAdmin?: boolean;
  onSuccess: () => Promise<void>;
  modalProps: BaseModalProps;
  profileInfo?: FullBOUserResponseModel;
};

export default function SelfEmployedProfileModal(props: Props) {
  const { formRef, isAdmin, modalProps, profileInfo, onSuccess } = props;
  const dispatch = useAppDispatch();

  const handleSubmit = async (values: SelfEmployedProfileFormValues) => {
    const data = mapSelftEployedProfileToRequest(values, profileInfo);

    const correctAction = isAdmin
      ? saveRecruiterSelfEmployedGeneralInfo
      : saveSelfEmployedGeneralInfo;

    const result = await dispatch(correctAction(data));

    if (correctAction.fulfilled.match(result)) {
      await onSuccess();

      BaseAlert.success('Profile changes saved.');
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
  };

  return (
    <BaseModal {...modalProps}>
      <SelfEmployedProfileForm
        formRef={formRef}
        onSubmit={handleSubmit}
        profileInfo={profileInfo}
        formFooter={
          <BaseModalFooter>
            <SubmitButton>Save</SubmitButton>
          </BaseModalFooter>
        }
      />
    </BaseModal>
  );
}
